<template>
  <div class="row">
    <div class="col-xs-12">
      <button
        type="button"
        class="btn btn-primary btn-voltar"
        @click="$router.back()"
      >
        <font-awesome-icon :icon="'arrow-left'" />
        Voltar
      </button>
      <h1 class="page-header">Salvar Meta</h1>
      <div class="row">
        <div class="col-xs-12 col-md-4">
          <div :class="['form-group', { 'has-error': errors.has('Logotipo') }]">
            <label class="control-label custom-font"
              >Logotipo
              <small> - Clique na imagem para adicionar:</small>
            </label>
            <div
              class="form-control"
              style="height:240px;width:320px;border-style:solid;padding:0px;border-radius:0px"
            >
              <img
                style="width:100%;height:100%"
                v-on:click="$upload.select('logo')"
                :src="image"
              />
            </div>
            <input
              type="hidden"
              ref="Logotipo"
              v-model="model.fileImagem"
              name="Logotipo"
            />
          </div>
        </div>

        <div class="col-xs-12 col-sm-8">
          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('Título') }]">
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('Título') }
                ]"
                >Título</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'id-card'"
                      :class="[{ 'is-danger': errors.has('Título') }]"
                    ></font-awesome-icon>
                  </span>
                  <input
                    ref="Título"
                    v-model="model.MET_DCTITULO"
                    name="Título"
                    maxlength="100"
                    placeholder="Título"
                    class="form-control"
                    v-validate="'required'"
                    type="text"
                  />
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('Título') }
                    ]"
                    v-text="100 - model.MET_DCTITULO.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('Título')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="Título"
                  class="help-block"
                  style=""
                  ><font-awesome-icon
                    :icon="'exclamation-triangle'"
                    :class="[{ 'is-danger': errors.has('Título') }]"
                  ></font-awesome-icon>
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div
              :class="['form-group', { 'has-error': errors.has('Objetivo') }]"
            >
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('Objetivo') }
                ]"
                >Objetivo</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'tags'"
                      :class="[{ 'is-danger': errors.has('Objetivo') }]"
                    ></font-awesome-icon>
                  </span>
                  <textarea
                    ref="Objetivo"
                    v-model="model.MET_DLOBJETIVO"
                    name="Objetivo"
                    placeholder="Objetivo"
                    maxlength="300"
                    class="form-control"
                    v-validate="'required'"
                    rows="3"
                  ></textarea>
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('Objetivo') }
                    ]"
                    v-text="300 - model.MET_DLOBJETIVO.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('Objetivo')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="Objetivo"
                  class="help-block"
                  style=""
                  ><font-awesome-icon
                    :icon="'exclamation-triangle'"
                    :class="[{ 'is-danger': errors.has('Objetivo') }]"
                  ></font-awesome-icon>
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-8">
            <div :class="['form-group', { 'has-error': errors.has('Link') }]">
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('Link') }
                ]"
                >Link</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'external-link-alt'"
                      :class="[{ 'is-danger': errors.has('Link') }]"
                    ></font-awesome-icon>
                  </span>
                  <input
                    ref="Link"
                    v-model="model.MET_DLLINK"
                    maxlength="200"
                    name="Link"
                    placeholder="Link"
                    class="form-control"
                    v-validate="'required'"
                    type="text"
                  />
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('Link') }
                    ]"
                    v-text="200 - model.MET_DLLINK.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('Link')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="Link"
                  class="help-block"
                  style=""
                  ><font-awesome-icon
                    :icon="'exclamation-triangle'"
                    :class="[{ 'is-danger': errors.has('Link') }]"
                  ></font-awesome-icon>
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-4">
            <div :class="['form-group', { 'has-error': errors.has('Número') }]">
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('Número') }
                ]"
                >Número [1-99]</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'sort-numeric-up-alt'"
                      :class="[{ 'is-danger': errors.has('Número') }]"
                    ></font-awesome-icon>
                  </span>
                  <input
                    type="text"
                    ref="Número"
                    v-model="model.MET_NRNUMERO"
                    name="Número"
                    placeholder="Número"
                    class="form-control"
                    v-validate="'required|numeric'"
                  />
                </div>
                <small
                  v-if="errors.has('Número')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="Número"
                  class="help-block"
                  ><font-awesome-icon
                    :icon="'exclamation-triangle'"
                    :class="[{ 'is-danger': errors.has('Número') }]"
                  ></font-awesome-icon>
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 text-right" style="padding-right:30px;">
          <button
            @click="save()"
            class="btn btn-default"
            :disabled="carregando"
          >
            <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'save'" />
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.fa-external-link-alt {
  color: #00615c;
}

.fa-tags {
  color: #00615c;
}

.fa-sort-numeric-up-alt {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.fa-external-link-alt.is-danger {
  color: #990000;
}

.fa-tags.is-danger {
  color: #990000;
}

.fa-sort-numeric-up-alt.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'
import imageDefault from '@/assets/image-default.png'
export default {
  name: 'meta-save',
  data() {
    return {
      carregando: false,
      image: imageDefault,
      hasInserted: true,
      model: {
        MET_NRNUMERO: 1,
        MET_DCTITULO: '',
        MET_DLOBJETIVO: '',
        MET_DLLINK: '',
        fileImagem: ''
      }
    }
  },
  created() {
    this.$upload.new('logo', {
      startOnSelect: false,
      extensions: ['jpeg', 'jpg', 'png', 'gif'],
      onSelect(files) {
        var me = this
        var m = this.model
        files[0].preview(file => {
          me.image = file.raw
          m.fileImagem = file.raw
        })
      }
    })
  },
  mounted() {
    var params = this.$router.history.current.params
    if (params.hasOwnProperty('MET_IDMETA')) {
      var me = this

      request
        .post(`meta/get`, { MET_IDMETA: params.MET_IDMETA })
        .then(result => {
          if (result.status) {
            me.model = result.data
            me.image =
              me.$root.$data.imgUrl +
              result.data.MET_DLURLIMAGEM +
              '?' +
              new Date().getTime()
            me.model.fileImagem = ''
            me.hasInserted = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  methods: {
    saveSuccess(result) {
      this.$router.push('list')
      this.$toastr.s('Sua meta foi salva com sucesso.')
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }
      })

      if (this.hasInserted && this.model.fileImagem.length === 0) {
        this.$toastr.e('Logotipo é obrigatório!')
      }

      request
        .post(`meta/save`, this.model)
        .then(this.saveSuccess)
        .catch(this.saveFail)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/metas/Save.vue